import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const TarjetasResumenKPI = ({ resumen, estatusBorrado }) => {
    const colSize = 3;
    const tituloTotal = estatusBorrado === 3 
        ? 'Total Borradas' 
        : (estatusBorrado === 2 
            ? 'Total No Borradas' 
            : (estatusBorrado === 1 ? 'Total Programadas' : 'Total Candidatas'));

    return (
        <Row className="g-2 mb-3">
            <Col sm={colSize}>
                <Card className="border-danger border-top border-4">
                    <Card.Body className="py-2 px-3">
                        <h6 className="text-700 mb-1">{tituloTotal}</h6>
                        <h3 className="mb-0 text-danger">{resumen?.iTotalCandidatas || 0}</h3>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={colSize}>
                <Card className="border-primary border-top border-4">
                    <Card.Body className="py-2 px-3">
                        <h6 className="text-700 mb-1">Licencias Nube</h6>
                        <h3 className="mb-0 text-primary">{resumen?.iTotalNube || 0}</h3>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={colSize}>
                <Card className="border-info border-top border-4">
                    <Card.Body className="py-2 px-3">
                        <h6 className="text-700 mb-1">Licencias AkasiaPOS</h6>
                        <h3 className="mb-0 text-info">{resumen?.iTotalAkasiaPOS || 0}</h3>
                    </Card.Body>
                </Card>
            </Col>
            {estatusBorrado === 0 ? (
                <Col sm={colSize}>
                    <Card className="border-warning border-top border-4">
                        <Card.Body className="py-2 px-3">
                            <h6 className="text-700 mb-1">Empresas con Ambas</h6>
                            <h3 className="mb-0 text-warning">{resumen?.iTotalAmbas || 0}</h3>
                        </Card.Body>
                    </Card>
                </Col>
            ) : (
                <Col sm={colSize}>
                    <Card className="border-warning border-top border-4">
                        <Card.Body className="py-2 px-3">
                            <h6 className="text-700 mb-1">Con Lic. Vigente</h6>
                            <h3 className="mb-0 text-warning">{resumen?.iTotalConLicenciaVigente || 0}</h3>
                        </Card.Body>
                    </Card>
                </Col>
            )}
        </Row>
    );
};

export default TarjetasResumenKPI;
